import { render, staticRenderFns } from "./TimedTooltip.vue?vue&type=template&id=481914d4&scoped=true"
import script from "./TimedTooltip.vue?vue&type=script&lang=js"
export * from "./TimedTooltip.vue?vue&type=script&lang=js"
import style0 from "./TimedTooltip.vue?vue&type=style&index=0&id=481914d4&scoped=true&lang=scss"
import style1 from "./TimedTooltip.vue?vue&type=style&index=1&id=481914d4&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481914d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('481914d4')) {
      api.createRecord('481914d4', component.options)
    } else {
      api.reload('481914d4', component.options)
    }
    module.hot.accept("./TimedTooltip.vue?vue&type=template&id=481914d4&scoped=true", function () {
      api.rerender('481914d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popups/TimedTooltip.vue"
export default component.exports